import { useState } from 'react';

interface Servicio {
  id: number;
  icon: string;
  title: string;
  description: string;
  detalle?: string;
  image: string;
}

export default function Servicios() {
  const [expandedCard, setExpandedCard] = useState(1);
  const [modalServicio, setModalServicio] = useState<Servicio | null>(null);

  const servicios: Servicio[] = [
    {
      id: 0,
      icon: 'ri-user-star-line',
      title: 'Asesoría Empresarial Personalizada',
      description: 'Acompañamiento técnico especializado para mejorar la gestión y operación de tu negocio.',
      detalle: `En el CDE MIPYME brindamos asesoría empresarial personalizada adaptada a las necesidades específicas de cada negocio. A través de un diagnóstico integral identificamos fortalezas, oportunidades de mejora y áreas críticas en gestión administrativa, financiera, comercial y operativa.\n\nNuestro acompañamiento técnico especializado permite diseñar planes de acción concretos, con metas claras e indicadores de seguimiento, orientados a mejorar la productividad, optimizar recursos y fortalecer la sostenibilidad del negocio. No ofrecemos soluciones genéricas, sino estrategias ajustadas a la realidad y etapa de crecimiento de cada empresa.`,
      image: 'https://static.readdy.ai/image/b286a2ed3ca10247dabf9d64ba360efd/e1be3b6a2b89de7cedd22d42e9774cac.jpeg'
    },
    {
      id: 1,
      icon: 'ri-graduation-cap-line',
      title: 'Capacitaciones y Formación',
      description: 'Programas de formación empresarial en gestión, finanzas, marketing y productividad.',
      detalle: `Desarrollamos programas de capacitación práctica y actualizada para fortalecer las capacidades empresariales de emprendedores y MIPYMES. Nuestros procesos formativos abarcan temas clave como gestión empresarial, educación financiera, marketing estratégico, transformación digital, productividad y mejora continua.\n\nLas capacitaciones combinan teoría aplicada, herramientas prácticas y casos reales, permitiendo que los participantes implementen de inmediato lo aprendido en sus negocios. Nuestro objetivo es impulsar empresarios más competitivos, resilientes y preparados para enfrentar los retos del mercado actual.`,
      image: 'https://static.readdy.ai/image/b286a2ed3ca10247dabf9d64ba360efd/1c952b5791947de32cfeeb082edc49b0.jpeg'
    },
    {
      id: 2,
      icon: 'ri-file-list-3-line',
      title: 'Apoyo en Formalización',
      description: 'Te guiamos en el proceso de registro y formalización legal de tu empresa.',
      detalle: `Te acompañamos paso a paso en el proceso de formalización legal de tu empresa, facilitando la comprensión de requisitos, trámites y obligaciones normativas. Brindamos orientación sobre registro mercantil, permisos municipales, obligaciones fiscales y otros aspectos necesarios para operar de manera formal.\n\nLa formalización no solo brinda seguridad jurídica, sino que abre oportunidades de acceso a financiamiento, participación en licitaciones, alianzas estratégicas y nuevos mercados. En el CDE te ayudamos a convertir tu negocio en una empresa estructurada y con bases sólidas para crecer.`,
      image: 'https://static.readdy.ai/image/099135a1a0137decf986b79a09f23af6/d868c2968cc1ffdbfd1ddaabefa0b0fc.jpeg'
    },
    {
      id: 3,
      icon: 'ri-lightbulb-line',
      title: 'Planes de Negocio',
      description: 'Desarrollo y estructuración de planes de negocio viables y atractivos para inversionistas.',
      detalle: `Apoyamos en la elaboración y estructuración de planes de negocio técnicamente sólidos, financieramente viables y estratégicamente bien definidos. Trabajamos en el análisis del mercado, propuesta de valor, modelo de ingresos, estructura de costos, proyecciones financieras y evaluación de riesgos.\n\nNuestros planes de negocio no solo sirven como documento formal, sino como una herramienta estratégica de gestión que orienta la toma de decisiones y facilita la presentación ante inversionistas, entidades financieras o programas de apoyo empresarial.`,
      image: 'https://static.readdy.ai/image/099135a1a0137decf986b79a09f23af6/abcf915b343dd2b4218b109a3f766498.jpeg'
    },
    {
      id: 4,
      icon: 'ri-store-3-line',
      title: 'Acceso a Mercados',
      description: 'Estrategias comerciales y conexiones para expandir tu presencia en el mercado regional.',
      detalle: `Impulsamos el crecimiento empresarial a través del desarrollo de estrategias comerciales efectivas y la generación de conexiones estratégicas. Apoyamos en la identificación de oportunidades en el mercado regional, fortalecimiento de la propuesta de valor, mejora de imagen comercial y estrategias de posicionamiento.\n\nAdemás, facilitamos la vinculación con redes empresariales, ferias comerciales, ruedas de negocio y potenciales compradores, permitiendo que las empresas amplíen su cartera de clientes y consoliden su presencia en el mercado. Nuestro enfoque es convertir el crecimiento comercial en un proceso planificado y sostenible.`,
      image: 'https://static.readdy.ai/image/099135a1a0137decf986b79a09f23af6/3d133d1a9eb0a85ac006b9025b89a9b2.jpeg'
    }
  ];

  return (
    <>
      <section id="servicios" className="py-32 bg-[#F8F9FA]">
        <div className="max-w-7xl mx-auto px-8 lg:px-16">
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4 lg:mb-0">
              Nuestros Servicios
            </h2>
            <p className="text-base text-gray-600 max-w-xl text-left lg:text-right">
              Ofrecemos un enfoque integral para el desarrollo y fortalecimiento de tu empresa en todas sus etapas.
            </p>
          </div>

          <div className="flex gap-6 h-[600px]">
            {servicios.map((servicio) => (
              <div
                key={servicio.id}
                className={`relative rounded-2xl overflow-hidden cursor-pointer transition-all duration-500 ${
                  expandedCard === servicio.id ? 'flex-[3]' : 'flex-[2]'
                }`}
                onMouseEnter={() => setExpandedCard(servicio.id)}
              >
                <img
                  src={servicio.image}
                  alt={servicio.title}
                  className="absolute inset-0 w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>

                <div className="absolute bottom-0 left-0 right-0 p-8">
                  <div className="w-10 h-10 bg-[#0066CC] rounded-full flex items-center justify-center mb-4">
                    <i className={`${servicio.icon} text-xl text-white`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3">{servicio.title}</h3>
                  <p className="text-white/90 text-sm leading-relaxed">{servicio.description}</p>
                  {servicio.detalle && (
                    <button
                      onClick={() => setModalServicio(servicio)}
                      className="mt-4 inline-flex items-center gap-2 bg-white/20 hover:bg-white/30 text-white text-sm font-medium px-4 py-2 rounded-full backdrop-blur-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
                    >
                      Ver más
                      <i className="ri-arrow-right-line text-base"></i>
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal */}
      {modalServicio && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-6"
          style={{ backgroundColor: 'rgba(0,0,0,0.6)' }}
          onClick={() => setModalServicio(null)}
        >
          <div
            className="bg-white rounded-2xl overflow-hidden max-w-2xl w-full shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Imagen superior */}
            <div className="relative h-56 w-full">
              <img
                src={modalServicio.image}
                alt={modalServicio.title}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              <button
                onClick={() => setModalServicio(null)}
                className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center bg-white/20 hover:bg-white/40 backdrop-blur-sm rounded-full text-white transition-all cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
              <div className="absolute bottom-5 left-6 flex items-center gap-3">
                <div className="w-10 h-10 bg-[#0066CC] rounded-full flex items-center justify-center">
                  <i className={`${modalServicio.icon} text-xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-white">{modalServicio.title}</h3>
              </div>
            </div>

            {/* Contenido */}
            <div className="p-8">
              {modalServicio.detalle?.split('\n\n').map((parrafo, i) => (
                <p key={i} className="text-gray-700 text-sm leading-relaxed mb-4 last:mb-0">
                  {parrafo}
                </p>
              ))}
              <div className="mt-6 flex justify-end">
                <a
                  href="#contacto"
                  onClick={() => setModalServicio(null)}
                  className="inline-flex items-center gap-2 bg-[#0066CC] hover:bg-[#0055AA] text-white text-sm font-semibold px-6 py-3 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  Solicitar asesoría
                  <i className="ri-arrow-right-line text-base"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
